import { render, staticRenderFns } from "./GeneralDetails.vue?vue&type=template&id=6b0986b4&scoped=true"
import script from "./GeneralDetails.vue?vue&type=script&lang=js"
export * from "./GeneralDetails.vue?vue&type=script&lang=js"
import style0 from "./GeneralDetails.vue?vue&type=style&index=0&id=6b0986b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0986b4",
  null
  
)

export default component.exports